// extracted by mini-css-extract-plugin
export default {"design":"Design_design__xAoK6"};